import { render, staticRenderFns } from "./referee.vue?vue&type=template&id=69a5c7a1&scoped=true"
import script from "./referee.vue?vue&type=script&lang=js"
export * from "./referee.vue?vue&type=script&lang=js"
import style0 from "./referee.vue?vue&type=style&index=0&id=69a5c7a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a5c7a1",
  null
  
)

export default component.exports